import {
    ASE_INTERNAL_MAINTENANCE_TICKET_FORM,
    ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM,
    ASE_INTERNAL_TICKET_FORM,
    FORM_FIELD_DEALER_NO,
    FORM_FIELD_INCIDENT_DATE,
    FORM_FIELD_ISSUE_IDENTIFIED,
    FORM_FIELD_ISSUE_ORIGIN,
    FORM_FIELD_ISSUE_STATED,
    FORM_FIELD_MAINTENANCE_PRIORITY,
    FORM_FIELD_MILEAGE_VERIFIED_BY_DEALER,
    FORM_FIELD_PRIORITY_JUSTIFICATION,
    FORM_FIELD_PRIORITY_TREATMENT,
    FORM_FIELD_PROBLEM_DESCRIPTION,
    FORM_FIELD_REQUEST_ROLE,
    FORM_FIELD_REQUESTOR_GROUP,
    FORM_FIELD_REQUESTOR_IPN,
    FORM_FIELD_REQUESTOR_NAME,
    FORM_FIELD_SOLUTION_GROUP,
    FORM_FIELD_TECHNICAL_BULLETIN_NUMBER,
    FORM_FIELD_VIN,
} from './formConstants';

export const editReqFields = {
    'DEFAULT': {
        'SG_EDITOR': {
            [ASE_INTERNAL_TICKET_FORM]: [
                FORM_FIELD_REQUESTOR_NAME,
                FORM_FIELD_REQUESTOR_IPN,
                FORM_FIELD_SOLUTION_GROUP,
                FORM_FIELD_REQUEST_ROLE,
                FORM_FIELD_ISSUE_ORIGIN,
                FORM_FIELD_PROBLEM_DESCRIPTION,
                FORM_FIELD_PRIORITY_TREATMENT
            ],
            [ASE_INTERNAL_MAINTENANCE_TICKET_FORM]: [
                FORM_FIELD_REQUESTOR_NAME,
                FORM_FIELD_DEALER_NO,
                FORM_FIELD_MAINTENANCE_PRIORITY,
                FORM_FIELD_VIN,
                FORM_FIELD_INCIDENT_DATE,
                FORM_FIELD_MILEAGE_VERIFIED_BY_DEALER,
                FORM_FIELD_ISSUE_IDENTIFIED,
                FORM_FIELD_PROBLEM_DESCRIPTION
            ],
            [ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM]: [
                FORM_FIELD_REQUESTOR_NAME,
                FORM_FIELD_REQUESTOR_GROUP,
                FORM_FIELD_PRIORITY_TREATMENT,
                FORM_FIELD_PRIORITY_JUSTIFICATION,
                FORM_FIELD_TECHNICAL_BULLETIN_NUMBER,
                FORM_FIELD_ISSUE_STATED,
                FORM_FIELD_PROBLEM_DESCRIPTION
            ]
        },
    }
};

export const createReqFields = {
    'DEFAULT': {
        [ASE_INTERNAL_TICKET_FORM]: [
            FORM_FIELD_REQUESTOR_NAME,
            FORM_FIELD_REQUESTOR_IPN,
            FORM_FIELD_SOLUTION_GROUP,
            FORM_FIELD_REQUEST_ROLE,
            FORM_FIELD_ISSUE_ORIGIN,
            FORM_FIELD_PROBLEM_DESCRIPTION,
            FORM_FIELD_PRIORITY_TREATMENT
        ],
        [ASE_INTERNAL_MAINTENANCE_TICKET_FORM]: [
            FORM_FIELD_REQUESTOR_NAME,
            FORM_FIELD_DEALER_NO,
            FORM_FIELD_MAINTENANCE_PRIORITY,
            FORM_FIELD_VIN,
            FORM_FIELD_INCIDENT_DATE,
            FORM_FIELD_MILEAGE_VERIFIED_BY_DEALER,
            FORM_FIELD_ISSUE_IDENTIFIED,
            FORM_FIELD_PROBLEM_DESCRIPTION
        ],
        [ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET_FORM]: [
            FORM_FIELD_REQUESTOR_NAME,
            FORM_FIELD_REQUESTOR_GROUP,
            FORM_FIELD_SOLUTION_GROUP,
            FORM_FIELD_PRIORITY_TREATMENT,
            FORM_FIELD_PRIORITY_JUSTIFICATION,
            FORM_FIELD_TECHNICAL_BULLETIN_NUMBER,
            FORM_FIELD_ISSUE_STATED,
            FORM_FIELD_PROBLEM_DESCRIPTION
        ]
    }
};
